import React from 'react';
import { Circular } from "../circular/Circular.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function CircularImage({
  size,
  className,
  centered,
  ...props
}) {
  return /*#__PURE__*/_jsx(Circular, {
    size: size,
    className: className,
    centered: centered,
    children: /*#__PURE__*/_jsx("img", {
      alt: props.alt,
      ...props
    })
  });
}